import { IFilter } from '../../types/filters';
import { ElevatorsContainer } from '../../containers/advancedFilters/ElevatorsContainer';

export const elevators: IFilter = {
  component: ElevatorsContainer,
};
